(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttn-edina-store"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('.ttn-concept__artwork')) return;
  const card = event.target.closest('.ttn-concept');
  const image = card.querySelector('.ttn-concept__image');
  const option = event.target.selectedOptions[0];
  if (!image || !option.dataset.image) return;
  image.removeAttribute('srcset');
  image.src = option.dataset.image;
  image.alt = card.querySelector('h3').textContent.trim() + ' — ' + option.textContent.trim();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttn-girls-b1-product"]) return;
  try {
    
document.querySelectorAll('[data-gb1-product]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
  const selectors=Array.from(root.querySelectorAll('[data-option-select]'));
  const price=root.querySelector('[data-price]');
  const addButton=root.querySelector('[data-add-to-cart]');
  const form=root.querySelector('form');
  const pantsStyle=root.querySelector('[data-pants-style]');
  const pantsSize=root.querySelector('[data-pants-size]');
  const pantsWrap=root.querySelector('[data-pants-size-wrap]');
  const pantsData=root.querySelector('[data-pants-variants]');
  const pantsVariants=pantsData?JSON.parse(pantsData.textContent):{};
  const error=root.querySelector('[data-cart-error]');
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:price.dataset.currency||'USD'});
  let busy=false;
  const selectedPants=()=>pantsStyle&&pantsStyle.value!=='none'?(pantsVariants[pantsStyle.value]||[]).find(v=>String(v.id)===pantsSize.value):null;
  const update=()=>{
    selectors.forEach((select,index)=>{
      const prefix=selectors.slice(0,index).map(el=>el.value);
      Array.from(select.options).forEach(option=>{
        const valid=variants.some(v=>prefix.every((value,i)=>v.options[i]===value)&&v.options[index]===option.value);
        option.disabled=!valid;
        option.hidden=!valid;
      });
      if(select.selectedOptions[0]?.disabled){const available=Array.from(select.options).find(o=>!o.disabled);select.value=available?available.value:'';}
    });
    const values=selectors.map(el=>el.value);
    const variant=selectors.length?variants.find(v=>v.options.every((value,i)=>value===values[i])):variants[0];
    root.querySelector('[data-variant-id]').value=variant?variant.id:'';
    const wantsPants=pantsStyle&&pantsStyle.value!=='none';
    const pants=selectedPants();
    const ready=variant&&variant.available&&(!wantsPants||(pants&&pants.available));
    let pantsPrice=0;
    if(wantsPants){const available=pantsVariants[pantsStyle.value]||[];pantsPrice=pants?pants.price:(available[0]?.price||0);}
    price.textContent=variant&&variant.price>0?formatter.format((variant.price+pantsPrice)/100)+(wantsPants?' '+root.dataset.totalLabel:''):price.dataset.pending;
    addButton.disabled=busy||!ready;
    addButton.textContent=variant&&variant.available?addButton.dataset.addLabel:addButton.dataset.unavailableLabel;
    const fields=root.querySelector('[data-sleeve-fields]');
    if(fields){const active=root.dataset.nameIncluded==='true';fields.hidden=!active;const input=fields.querySelector('input');input.disabled=!active;input.required=active;}
  };
  const changePants=()=>{
    const selected=pantsStyle.value;
    const active=selected!=='none';
    pantsWrap.hidden=!active;
    pantsSize.disabled=!active;
    pantsSize.required=active;
    pantsSize.replaceChildren(new Option(pantsSize.dataset.placeholder,''));
    if(active){
      (pantsVariants[selected]||[]).forEach(v=>{
        const option=new Option(v.title,String(v.id));
        option.disabled=!v.available;
        pantsSize.add(option);
      });
      root.querySelector('[data-pants-note]').textContent=selected==='joggers'?root.dataset.joggerNote:root.dataset.widelegNote;
    }
    if(!active)root.querySelector('[data-pants-note]').textContent=root.dataset.optionalNote;
    error.hidden=true;
    update();
  };
  selectors.forEach(el=>el.addEventListener('change',update));
  if(pantsStyle){
    pantsStyle.addEventListener('change',changePants);
    pantsSize.addEventListener('change',()=>{error.hidden=true;update();});
    changePants();
    form.addEventListener('submit',async event=>{
      if(pantsStyle.value==='none')return;
      event.preventDefault();
      if(busy||!form.reportValidity())return;
      const pants=selectedPants();
      if(!pants||!pants.available)return;
      const formData=new FormData(form);
      const properties={};
      for(const [key,value] of formData){const match=key.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=String(value);}
      const pantsProperties={Team:'Minnetonka Girls B1 Hockey'};
      if(properties['Player Name'])pantsProperties['Player Name']=properties['Player Name'];
      const items=[{id:Number(formData.get('id')),quantity:1,properties},{id:pants.id,quantity:1,properties:pantsProperties}];
      busy=true;error.hidden=true;update();
      try{
        const response=await fetch(root.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error('cart add failed');
        window.location.assign(root.dataset.cartUrl);
      }catch(caught){error.textContent=root.dataset.pantsError;error.hidden=false;busy=false;update();}
    });
  }else update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttn-team-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ttn-team-directory')) {
  customElements.define('ttn-team-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const input = this.querySelector('[data-team-search]');
      if (!input) return;
      input.addEventListener('input', () => {
        const term = input.value.trim().toLocaleLowerCase();
        let count = 0;
        this.querySelectorAll('[data-team-name]').forEach(card => {
          card.hidden = !card.dataset.teamName.toLocaleLowerCase().includes(term);
          if (!card.hidden) count++;
        });
        const empty = this.querySelector('[data-team-empty]');
        if (empty) empty.hidden = count !== 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttn-team-store"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('.ttn-concept__artwork')) return;
  const card = event.target.closest('.ttn-concept');
  const image = card.querySelector('.ttn-concept__image');
  const option = event.target.selectedOptions[0];
  if (!image || !option.dataset.image) return;
  image.removeAttribute('srcset');
  image.src = option.dataset.image;
  image.alt = card.querySelector('h3').textContent.trim() + ' — ' + option.textContent.trim();
});

  } catch(e) { console.error(e); }
})();
})();
